(function(angular) {
    'use strict';

    angular.module('um.commonFilters').filter('highlight', highlightFilter);
    function highlightFilter() {
        return function(text, phrase) {
            var str = text;
            if (!str) {
                return '';
            }

            str = str.replace(/<span class="highlighted">(.*)<\/span>/gi, '$1');

            if (phrase) {
                str = str.replace(new RegExp('(' + phrase + ')', 'gi'), '<span class="highlighted">$1</span>');
            }
            return str;
        };
    }
})(window.angular);
